import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import { H5, Image } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";
import CountdownData from "../Common/CountdownData";

const SimpleComingSoon = () => {
  return (
    <div className="page-wrapper compact-wrapper" id="pageWrapper">
      <Container className="p-0" fluid>
        <div className="comingsoon">
          <div className="comingsoon-inner text-center">
            <Link to={`${process.env.PUBLIC_URL}/dashboard/default`}>
              <Image className="for-dark" src={dynamicImage(`logo/logo_dark.png`)} alt="logo" />
              <Image className="for-light" src={dynamicImage(`logo/logo.png`)} alt="logo" />
            </Link>
            <H5>{"WE ARE COMING SOON"}</H5>
            <div className="countdown" id="clock-arrival">
              <CountdownData />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
export default SimpleComingSoon;